<template>
    <div class="container-fluid mt-5">
      <div>
        <card
          class="no-border-card"
          body-classes="px-0 pb-1"
          footer-classes="pb-2"
        >
          <template slot="header">
            <div class="row">
              <div class="col-6">
                <h3 class="mb-0">Canje Masivo de Boletos</h3>
              </div>
              <div class="col-6 text-right">
                
              </div>
            </div>
          </template>
          <div class="col-6 mb-3">
            <span>Resumen de Rutas con Boletos en Limbo</span>
            <el-table
            class="table-responsive align-items-center table-flush"
            header-row-class-name="thead-light"
            :data="rutasLimbo"
            @sort-change="sortChange"
            type="index"
            >
            <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
            </div>
            <div slot="empty" v-if="rutasLimbo">
                Sin datos disponibles
            </div>
            <el-table-column label="Ruta" min-width="180px">
              <div slot-scope="{ row }" class="table-actions">
                <span>{{ row.abreviatura_origen +' - '+ row.abreviatura_destino }}</span>
              </div>
            </el-table-column>
            <el-table-column label="Boletos" prop="boletosEnlimbo" />
            </el-table>
          </div>
          <!-- SELECT CORRIDA ORIGEN -->
          <span class="ml-3">Corrida de origen</span>
          <v-select 
            placeholder="Seleccione corrida"
            :options="paginated"
            :filterable="false" 
            @search="onSearch"
            label="name"
            @input="setSelectedOrigen" 
            class="mb-0 col-6">
            <li slot="list-footer" class="pagination">
            <button :disabled="!hasPrevPage" @click="offset -= limit">Anterior</button>
            <button :disabled="!hasNextPage" @click="offset += limit">Siguiente</button>
            </li>
            <span slot="no-options" @click="$refs.select.open = false">
              Sin datos disponibles
            </span>
          </v-select>
          <!-- TABLA DESPUES DE SELECT ORIGEN CON LIMBO -->
          <div v-if="boletos_limbo != null" class="col-12 mt-3">
            <span><strong>Boletos en limbo de Ruta {{  }}</strong></span>
            <el-table
            class="table-responsive align-items-center table-flush"
            style="cursor: pointer;"
            header-row-class-name="thead-light"
            :data="boletos_limbo"
            @sort-change="sortChange"
            highlight-current-row
            @current-change="iniciaCambiaAsientoTabla"
            >
            <div slot="empty" v-if="loading">
                <img src="/img/loading.gif" style="height: 100px; width: 100px" />
            </div>
            <div slot="empty" v-if="boletos_limbo">
                Sin datos disponibles
            </div>
            <el-table-column label="# Corrida" min-width="100px">
              <div slot-scope="{ row }" class="table-actions">
                  <span>{{ row.corrida_id  }}</span>
              </div>
            </el-table-column>
            <el-table-column label="Asiento" prop="asiento" />
            <el-table-column label="Fecha" min-width="200px">
              <div slot-scope="{ row }" class="table-actions">
                  <span v-for="boleto in row.boletos">{{ boleto.fecha_salida | moment('DD-MM-YYYY') }}<br></span>
              </div>
            </el-table-column>
            <el-table-column label="Hora" min-width="200px">
              <div slot-scope="{ row }" class="table-actions">
                <span v-for="boleto in row.boletos">{{ boleto.fecha_salida | moment('HH:mm') }}<br></span>
              </div>
            </el-table-column>
            <el-table-column label="Categoría" prop="nombre_categoria_asiento" />
            <el-table-column label="Pasajero" min-width="200px">
              <div slot-scope="{ row }" class="table-actions">
                  <span v-for="boleto in row.boletos">{{ boleto.nombre_pasajero +'/'+ boleto.abreviatura_terminal_origen +'-'+ boleto.abreviatura_terminal_destino }} <br></span>
              </div>
            </el-table-column>
            </el-table>
            <div
              slot="footer"
              class="col-12 d-flex justify-content-center flex-wrap"
            >
              <base-pagination
                class="pagination-no-border justify-content-right"
                v-model="pagination.currentPage"
                :per-page="pagination.perPage"
                :total="total"
              />
            </div>
          </div>

          <!-- ASIENTOS DESPUES DE SELECT ORIGEN SIN LIMBO -->
          <div v-if="boletos != null" class="col-12 mt-3">
            <span><strong>Layout corrida: {{  }}</strong></span>
            <label v-if="parseInt(boletos.niveles) === 2">&nbsp;&nbsp;&nbsp;Estas en el nivel:&nbsp;{{nivelActual}}</label>
            <div v-if="mostrarNivelUno">
              <div v-for="(column,indexColumn) in boletos.estructura[0]" :key="indexColumn" class="d-flex flex-row align-content-around flex-wrap">
                <box-item-canje 
                  :cambiaAsiento="cambiaAsiento"
                  :layoutDestino="layoutDestino"
                  :iniciaCambiaAsiento="iniciaCambiaAsiento"
                  :ref="'item'+(indexColumn).toString()+indexFila"
                  :id="'item'+(indexColumn).toString()+indexFila"
                  v-model="boletos.estructura[0][indexColumn][indexFila]" 
                  v-for="(fila,indexFila) in column" :key="(indexColumn).toString()+indexFila"
                ></box-item-canje>
              </div>
            </div>
            <div v-show="mostrarNivelDos">
              <div v-if="parseInt(boletos.niveles) === 2" class="col-12">
                <div v-if="boletos.estructura[1].length > 0">
                  <div v-for="(column,indexColumn) in boletos.estructura[1]" :key="indexColumn" class="d-flex flex-row align-content-around flex-wrap">
                    <box-item-canje 
                      :cambiaAsiento="cambiaAsiento"
                      :layoutDestino="layoutDestino"
                      :iniciaCambiaAsiento="iniciaCambiaAsiento"
                      :ref="'item2'+(indexColumn).toString()+indexFila"
                      :id="'item2'+(indexColumn).toString()+indexFila"
                      v-model="boletos.estructura[1][indexColumn][indexFila]" 
                      v-for="(fila,indexFila) in column" :key="(indexColumn).toString()+indexFila"
                    ></box-item-canje>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <div v-if="parseInt(boletos.niveles) === 2" class="App__basic-example-controls text-center">
              <button class="btn btn-default hover-apolo" @click.prevent="nivelUno()">
                &laquo; Nivel 1
              </button>
              <button class="btn btn-default hover-apolo" @click.prevent="nivelDos()">
                Nivel 2 &raquo;
              </button>
            </div>
            <br>
          </div>

          <div v-if="boletos != null || boletos_limbo != null">
            <div class="col-12 mt-3">
              <div v-if="cambiaAsiento === true"  class="alert alert-dark col-6" role="alert">
                A continuación, selecciona un asiento disponible del layout corrida destino.
              </div>
            </div>
            <span class="ml-3">Corrida de destino</span>
            <v-select 
              placeholder="Seleccione corrida"
              :options="paginatedDestino"
              :filterable="false" 
              @search="onSearchDestino" 
              label="name"
              @input="setSelectedDestino" 
              class="mb-0 col-6">
              <li slot="list-footer" class="pagination">
              <button :disabled="!hasPrevPageDestino" @click="offsetDestino -= limitDestino">Anterior</button>
              <button :disabled="!hasNextPageDestino" @click="offsetDestino += limitDestino">Siguiente</button>
              </li>
              <span slot="no-options" @click="$refs.select.open = false">
                Sin datos disponibles
              </span>
            </v-select>
          </div>
          <div v-if="layoutDestino != null" class="col-12 mt-3">
            <label v-if="parseInt(layoutDestino.niveles) === 2">&nbsp;&nbsp;&nbsp;Estas en el nivel:&nbsp;{{nivelActualNuevo}}</label>
            <div v-if="mostrarNivelUnoNuevo">
              <div v-for="(column,indexColumn) in layoutDestino.estructura[0]" :key="indexColumn" class="d-flex flex-row align-content-around flex-wrap">
                <box-item-canje-new 
                  :canje="canje"
                  :cambiaAsiento="cambiaAsiento"
                  :asientoACopiar="asientoACopiar"
                  :terminaCambioAsiento="terminaCambioAsiento"
                  :terminaCambioAsientoTabla="terminaCambioAsientoTabla"
                  :boletos="boletos"
                  :boletos_limbo="boletos_limbo"
                  :ref="'new'+(indexColumn).toString()+indexFila"
                  :id="'new'+(indexColumn).toString()+indexFila"
                  v-model="layoutDestino.estructura[0][indexColumn][indexFila]" 
                  v-for="(fila,indexFila) in column" :key="(indexColumn).toString()+indexFila"
                ></box-item-canje-new>
              </div>
            </div>
            <div v-show="mostrarNivelDosNuevo">
              <div v-if="parseInt(layoutDestino.niveles) === 2" class="col-12">
                <div v-if="layoutDestino.estructura[1].length > 0">
                  <div v-for="(column,indexColumn) in layoutDestino.estructura[1]" :key="indexColumn" class="d-flex flex-row align-content-around flex-wrap">
                    <box-item-canje-new
                      :canje="canje"
                      :cambiaAsiento="cambiaAsiento"
                      :asientoACopiar="asientoACopiar"
                      :terminaCambioAsiento="terminaCambioAsiento"
                      :terminaCambioAsientoTabla="terminaCambioAsientoTabla"
                      :boletos="boletos"
                      :boletos_limbo="boletos_limbo"
                      :ref="'new2'+(indexColumn).toString()+indexFila"
                      :id="'new2'+(indexColumn).toString()+indexFila"
                      v-model="layoutDestino.estructura[1][indexColumn][indexFila]" 
                      v-for="(fila,indexFila) in column" :key="(indexColumn).toString()+indexFila"
                    ></box-item-canje-new>
                  </div>
                </div>
              </div>
            </div>
            <br>
            <div v-if="parseInt(layoutDestino.niveles) === 2" class="App__basic-example-controls text-center">
              <button class="btn btn-default hover-apolo" @click.prevent="nivelUnoNuevo()">
                &laquo; Nivel 1
              </button>
              <button class="btn btn-default hover-apolo" @click.prevent="nivelDosNuevo()">
                Nivel 2 &raquo;
              </button>
            </div>
          </div>
        </card>
      </div>
    </div>
</template>
<script>
import moment from 'moment';
import BoxItemCanje from './BoxItemCanje.vue';
import BoxItemCanjeNew from './BoxItemCanjeNew.vue';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { BasePagination } from "@/components/";
import {
Table,
TableColumn,
DropdownMenu,
DropdownItem,
Dropdown,
Tooltip,
Select,
Option,
RadioButton,
Button,
} from "element-ui";
import swal from "sweetalert2";
import "sweetalert2/dist/sweetalert2.css";
import formMixin from "@/mixins/form-mixin";
import { throws } from 'assert';

export default {
layout: "DashboardLayout",

components: {
    BoxItemCanjeNew,
    BoxItemCanje,
    vSelect,
    BasePagination,
    [Tooltip.name]: Tooltip,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [Select.name]: Select,
    [Option.name]: Option,
    [Button.name]: Button,
},

mixins: [formMixin],

data() {
    return {
    rutasLimbo: [],
    corridasOrigen: [],
    corridasDestino: [],
    boletos: null,
    boletos_limbo: null,
    search: '',
    searchDestino: '',
    offset: 0,
    limit: 15,
    offsetDestino: 0,
    limitDestino: 15,
    selectedRows: [],
    query: null,

    sort: "created_at",

    pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [{value:'5', descripcion: '5 rutas con boletos en limbo por página'},
        {value:'10', descripcion: '10 rutas con boletos en limbo por página'},
        {value:'25', descripcion: '25 rutas con boletos en limbo por página'},
        {value:'50', descripcion: '50 rutas con boletos en limbo por página'}],
    },
    total: 0,
    loading: true,
    canje: {
        type: "boleto",
        corrida_destino_id: null,
        asiento_destino: null,
        boletos: []
    },
    mostrarNivelUno: true,
    mostrarNivelDos: false,
    mostrarNivelUnoNuevo: true,
    mostrarNivelDosNuevo: false,
    layoutDestino: null,
    nivelActual: '1',
    nivelActualNuevo: '1',
    asientoACopiar: null,
    cambiaAsiento: false,
    indexAsiento: null,
    };
},

mounted() {
    this.getRutasLimbo();
    this.getCorridasOrigen();
},

computed: {
    from() {
        return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
    let highBound = this.from + this.pagination.perPage;
    if (this.total < highBound) {
        highBound = this.total;
    }
        return highBound;
    },
    filtered() {
      const searchLower = this.search.toLowerCase().trim();

      // Si no hay nada en la búsqueda, retornamos el array original directamente
      if (!searchLower) return this.corridasOrigen;

      return this.corridasOrigen.filter((item) => {
        // 1. Armamos exactamente el mismo label que usas en la vista
        const label = item.es_limbo === 0 ? `${item.abreviatura_origen}-${item.abreviatura_destino} #${item.corrida_id} ${moment(item.fecha_salida).format('MMMM DD - HH:mm')}hrs` : `Limbo ${item.abreviatura_origen}-${item.abreviatura_destino}`;

        // 2. Evaluamos si el label contiene el texto ingresado
        return label.toLowerCase().includes(searchLower);
      });
    },
    paginated() {
      return this.filtered.slice(this.offset, this.limit + this.offset).map(function(item){
        if(item.es_limbo === 0){
          return { sid: item.sid,
                   corrida_id: item.corrida_id,
                   ruta_id: item.ruta_id,
                   es_limbo: item.es_limbo,
                   name: item.abreviatura_origen +'-'+ item.abreviatura_destino +' #'+ item.corrida_id+' '+ moment(item.fecha_salida).format('MMMM DD - HH:mm')  +'hrs' }
        }else{
          return { sid: item.sid, 
                   corrida_id: item.corrida_id,
                   ruta_id: item.ruta_id,
                   es_limbo: item.es_limbo,
                   name: 'Limbo '+item.abreviatura_origen +'-'+ item.abreviatura_destino }
        }
      })
    },
    hasNextPage() {
      const nextOffset = this.offset + this.limit
      return Boolean(
        this.filtered.slice(nextOffset, this.limit + nextOffset).length
      )
    },
    hasPrevPage() {
      const prevOffset = this.offset - this.limit
      return Boolean(
        this.filtered.slice(prevOffset, this.limit + prevOffset).length
      )
    },
    filteredDestino() {
        const searchLower = this.searchDestino.toLowerCase().trim();

          // Si no hay nada en la búsqueda, retornamos el array original directamente
          if (!searchLower) return this.corridasDestino;

          return this.corridasDestino.filter((item) => {
            // 1. Armamos exactamente el mismo label que usas en la vista
            const label = `${item.abreviatura_origen}-${item.abreviatura_destino} #${item.corrida_id} ${moment(item.fecha_salida).format('MMMM DD - HH:mm')}hrs`;

            // 2. Evaluamos si el label contiene el texto ingresado
            return label.toLowerCase().includes(searchLower);
          });
    },
    paginatedDestino() {
      return this.filteredDestino.slice(this.offsetDestino, this.limitDestino + this.offsetDestino).map(function(item){
        return { sid: item.sid, 
                 corrida_id: item.corrida_id,
                 ruta_id: item.ruta_id,
                 es_limbo: item.es_limbo,
                 name: item.abreviatura_origen +'-'+ item.abreviatura_destino +' #'+ item.corrida_id+' '+ moment(item.fecha_salida).format('MMMM DD - HH:mm')  +'hrs' }
      })
    },
    hasNextPageDestino() {
      const nextOffset = this.offsetDestino + this.limitDestino
      return Boolean(
        this.filteredDestino.slice(nextOffset, this.limitDestino + nextOffset).length
      )
    },
    hasPrevPageDestino() {
      const prevOffset = this.offsetDestino - this.limitDestino
      return Boolean(
        this.filteredDestino.slice(prevOffset, this.limitDestino + prevOffset).length
      )
    },
},

watch: {
    query: {
    handler: "getListDebounced",
    immediate: true,
    },
    pagination: {
    handler: "getList",
    immediate: false,
    deep: true,
    },
},

methods: {
    iniciaCambiaAsientoTabla(row){
      if(row === null){ return; };
      if(this.layoutDestino === null){
          this.$notify({
          type: "danger",
          message: "¡Es necesario seleccionar una corrida destino para iniciar cambio de asientos!",
          duration: -1
          });
          return;
      }else{
        this.asientoACopiar = row;
        this.canje.boletos = row.boletos;
        this.$notify({
          type: "success",
          message: "Boleto en limbo seleccionado correctamente.",
          duration: -1
        });
        this.cambiaAsiento = true;
      }
    },

    terminaCambioAsientoTabla(){
      for(let i = 0; i < this.boletos_limbo.length; i++){
        if(this.boletos_limbo[i].asiento === this.asientoACopiar.asiento){
          this.boletos_limbo.splice(i,1);
          this.cambiaAsiento = false;
          this.asientoACopiar = null;
          break;
        }
      }
    },

    terminaCambioAsiento(){
      if(this.mostrarNivelUno){
        for(let i = 0; i < 5; i++){
          for(let j = 0; j < this.boletos.estructura[0][i].length; j++){
            if(this.boletos.estructura[0][i][j] != null){
              if(this.boletos.estructura[0][i][j].seleccionado === true){
                this.cambiaAsiento = false;
                this.asientoACopiar = null;
                const id = 'item'+i+(j.toString());
                const item = this.$refs[id];
                item[0].tipo = null;
                item[0].numero = null;
                item[0].categoria = null;
                item[0].pantalla = false;
                item[0].cantidadBoletos = null;
                this.boletos.estructura[0][i][j] = null;
              }
            }
          }
        }
      }
      if(this.mostrarNivelDos){
        for(let i = 0; i < 5; i++){
          for(let j = 0; j < this.boletos.estructura[1][i].length; j++){
            if(this.boletos.estructura[1][i][j] != null){
              if(this.boletos.estructura[1][i][j].seleccionado === true){
                this.cambiaAsiento = false;
                this.asientoACopiar = null;
                const id = 'item2'+i+(j.toString());
                const item = this.$refs[id];
                item[0].tipo = null;
                item[0].numero = null;
                item[0].categoria = null;
                item[0].pantalla = false;
                item[0].cantidadBoletos = null;
                this.boletos.estructura[1][i][j] = null;
              }
            }
          }
        }
      }
    },

    iniciaCambiaAsiento(asiento){
      this.asientoACopiar = asiento;
      this.canje.boletos = asiento.boletos;
      this.cambiaAsiento = true;
    },

    setSelectedDestino(value){
      this.layoutDestino = null;
      if(value === null){
        return;
      }else{
        this.canje.corrida_destino_id = value.corrida_id;
        this.getSelectedDestino(value);
      }
    },

    async getSelectedDestino(value){
      await this.$store.dispatch("corridas/getInfoCanje", value).then(() => {
        this.layoutDestino = this.$store.getters["corridas/getInfoCanje"];
      });
    },

    setSelectedOrigen(value){
      this.boletos = null;
      this.boletos_limbo = null;
      if(value === null){
        this.boletos = null
        this.boletos_limbo = null;
        return;
      }else{
        this.getSelectedOrigen(value);
      }
    },

    async getSelectedOrigen(value){
      await this.$store.dispatch("corridas/getInfoCanje", value).then(() => {
        if(value.es_limbo === 1){
          this.boletos_limbo = this.$store.getters["corridas/getInfoCanje"];
          console.log(this.boletos_limbo)
          this.total = this.boletos_limbo.length;
        }else{
          this.boletos = this.$store.getters["corridas/getInfoCanje"];
        }
        this.getCorridasDestino(value);
      });
    },

    onSearch(query) {
      this.search = query
      this.offset = 0
    },

    onSearchDestino(query) {
      this.searchDestino = query
      this.offsetDestino = 0
    },

    getListDebounced: _.debounce(function () {
    this.getList();
    }, 300),

    async getList() {
    let params = {
        ...(this.sort ? { sort: this.sort } : {}),
        filter: {
        ...(this.query ? { terminal: this.query } : {}),
        ...(this.query ? { nombre: this.query } : {}),
        },
        page: {
        number: this.pagination.currentPage,
        size: this.pagination.perPage,
        },
    };

    await this.$store.dispatch("agencias/list", params).then(() => {
        this.agencias = this.$store.getters["agencias/list"];
        this.total = this.$store.getters["agencias/listTotal"];
    });
    this.loading = false;
    },

    async getRutasLimbo() {
      await this.$store.dispatch("corridas/getRutasConLimbos").then(() => {
          this.rutasLimbo = this.$store.getters["corridas/getRutasConLimbos"];
      });
    },

    async getCorridasOrigen() {
      await this.$store.dispatch("corridas/getCorridasOrigen").then(() => {
          this.corridasOrigen = this.$store.getters["corridas/getCorridasOrigen"];
      });
    },

    async getCorridasDestino(value) {
      await this.$store.dispatch("corridas/getCorridasDestino", value).then(() => {
          this.corridasDestino = this.$store.getters["corridas/getCorridasDestino"];
      });
    },

    nivelUno(){   
      this.mostrarNivelUno = true;
      this.mostrarNivelDos = false;
      this.nivelActual = '1';
    },

    nivelDos(){
      this.mostrarNivelUno = false;
      this.mostrarNivelDos = true;
      this.nivelActual = '2';
    },

    nivelUnoNuevo(){   
      this.mostrarNivelUnoNuevo = true;
      this.mostrarNivelDosNuevo = false;
      this.nivelActualNuevo = '1';
    },

    nivelDosNuevo(){
      this.mostrarNivelUnoNuevo = false;
      this.mostrarNivelDosNuevo = true;
      this.nivelActualNuevo = '2';
    },
    
    nombreConAbreviatura ({ nombre, abreviatura }) {
    return `${nombre} — ${abreviatura}`
    },

    sortChange({ prop, order }) {
    if (order === "descending") {
        this.sort = `-${prop}`;
    } else {
        this.sort = `${prop}`;
    }
    this.getList();
    },
},
};
</script>
<style>
.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
}
.pagination button:hover {
  cursor: pointer;
}
.hoverApolo:hover{
    background-color: #6074dd !important;
    color: #fff !important;
}
div.el-table .el-table__row:hover{
  background: #edf5ff !important;
}
</style>
